/* Variant Media Grouping — substituto nativo da StarApps Variant Image Automator
 * -------------------------------------------------------------------------------
 * MODO AUTOMÁTICO (igual à StarApps): as imagens são agrupadas pela ordem no produto.
 *   A imagem atribuída a uma variante inicia um grupo; todas as imagens seguintes
 *   pertencem a esse grupo, até surgir a imagem atribuída de outra variante.
 *   Imagens ANTES da primeira imagem de variante são partilhadas (aparecem sempre).
 * MODO MANUAL (override opcional): tokens #valor-da-opcao no alt text da imagem.
 *   Ex.: "Viseira NEXX #dark-smoke". Se existirem tokens, têm prioridade sobre o modo automático.
 */
(function () {
  const HIDDEN_CLASS = 'variant-media-hidden';
  const TOKEN_RE = /#([a-z0-9][a-z0-9\-_]*)/gi;

  const style = document.createElement('style');
  style.textContent = '.' + HIDDEN_CLASS + '{display:none !important;}';
  document.head.appendChild(style);

  function handleize(s) {
    return String(s || '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .trim()
      .replace(/['"\u2019]/g, '')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  function tokensFromAlt(alt) {
    const tokens = [];
    let m;
    TOKEN_RE.lastIndex = 0;
    while ((m = TOKEN_RE.exec(alt || ''))) tokens.push(handleize(m[1]));
    return tokens;
  }

  function mediaIdFrom(item) {
    const raw = item.getAttribute('data-media-id') || item.getAttribute('data-target') || '';
    const parts = raw.split('-');
    return parts[parts.length - 1];
  }

  function groupsMap(productInfo) {
    const script = productInfo.querySelector('script[data-variant-media-groups]');
    if (!script) return null;
    try {
      return JSON.parse(script.textContent);
    } catch (e) {
      return null;
    }
  }

  function selectedVariant(productInfo) {
    const s = productInfo.querySelector('variant-selects script[type="application/json"][data-selected-variant]');
    if (!s) return null;
    try {
      return JSON.parse(s.textContent);
    } catch (e) {
      return null;
    }
  }

  function selectedValues(productInfo) {
    const values = new Set();
    const v = selectedVariant(productInfo);
    if (v) {
      const opts = v.options || [v.option1, v.option2, v.option3];
      (opts || []).forEach(function (o) { if (o) values.add(handleize(o)); });
    }
    productInfo
      .querySelectorAll('variant-selects input[type="radio"]:checked, variant-selects select option:checked')
      .forEach(function (el) { values.add(handleize(el.value || el.textContent)); });
    return values;
  }

  function applyFilter(productInfo) {
    if (!productInfo) return;
    const gallery = productInfo.querySelector('media-gallery');
    if (!gallery) return;
    const items = gallery.querySelectorAll('[data-media-alt]');
    if (!items.length) return;

    const values = selectedValues(productInfo);
    const groups = groupsMap(productInfo);
    const variant = selectedVariant(productInfo);
    const groupKey = variant && variant.featured_media ? String(variant.featured_media.id) : null;

    const decisions = [];
    items.forEach(function (item) {
      const tokens = tokensFromAlt(item.getAttribute('data-media-alt'));
      let show;
      if (tokens.length) {
        // Override manual por alt text
        show = tokens.some(function (t) { return values.has(t); });
      } else if (groups && groupKey) {
        // Agrupamento automático por posição (lógica StarApps)
        const g = groups[mediaIdFrom(item)];
        show = g === undefined || g === '' || g === groupKey;
      } else {
        show = true;
      }
      decisions.push([item, show]);
    });

    // Fail-safe: se nenhuma imagem principal ficar visível, mostra todas.
    const mainVisible = decisions.filter(function (d) {
      return d[1] && d[0].classList.contains('product__media-item');
    }).length;
    const failSafe = mainVisible === 0;

    const hiddenMediaIds = [];
    let visibleCount = 0;

    decisions.forEach(function (d) {
      const item = d[0];
      const visible = failSafe ? true : d[1];
      item.classList.toggle(HIDDEN_CLASS, !visible);
      if (item.classList.contains('product__media-item')) {
        if (visible) {
          visibleCount++;
        } else {
          const mediaId = mediaIdFrom(item);
          if (mediaId) hiddenMediaIds.push(mediaId);
        }
      }
    });

    // Atualiza o contador do slider (1 / N)
    const total = gallery.querySelector('.slider-counter--total');
    if (total) total.textContent = visibleCount;

    // Re-inicializa os sliders (galeria + thumbnails)
    gallery.querySelectorAll('slider-component').forEach(function (s) {
      if (typeof s.resetPages === 'function') s.resetPages();
      else if (typeof s.initPages === 'function') s.initPages();
    });

    // Garante que a imagem ativa está visível
    const active = gallery.querySelector('.product__media-item.is-active');
    if (!active || active.classList.contains(HIDDEN_CLASS)) {
      const first = gallery.querySelector('.product__media-item:not(.' + HIDDEN_CLASS + ')');
      if (first && typeof gallery.setActiveMedia === 'function') {
        gallery.setActiveMedia(first.getAttribute('data-media-id'), true);
      }
    }

    // Esconde as mesmas imagens no modal de zoom
    const sectionId = gallery.id.replace('MediaGallery-', '');
    const modal = document.getElementById('ProductModal-' + sectionId);
    if (modal) {
      modal.querySelectorAll('[data-media-id]').forEach(function (el) {
        const id = el.getAttribute('data-media-id') || '';
        const hidden = hiddenMediaIds.some(function (mid) {
          return id === mid || id.slice(-mid.length) === mid;
        });
        el.classList.toggle(HIDDEN_CLASS, hidden && !failSafe);
      });
    }
  }

  function initAll() {
    document.querySelectorAll('product-info').forEach(applyFilter);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Reaplica o filtro depois de o Dawn atualizar a galeria na mudança de variante
  if (window.subscribe && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.variantChange) {
    window.subscribe(window.PUB_SUB_EVENTS.variantChange, function (event) {
      let productInfo = null;
      if (event && event.data && event.data.sectionId) {
        productInfo = document.getElementById('MainProduct-' + event.data.sectionId);
      }
      if (!productInfo) productInfo = document.querySelector('product-info');
      requestAnimationFrame(function () {
        setTimeout(function () { applyFilter(productInfo); }, 0);
      });
    });
  }

  // Fallback: qualquer mudança no seletor de variantes
  document.addEventListener('change', function (e) {
    const vs = e.target && e.target.closest ? e.target.closest('variant-selects') : null;
    if (!vs) return;
    const pi = vs.closest('product-info') || document.querySelector('product-info');
    setTimeout(function () { applyFilter(pi); }, 350);
  });
})();
